import { Copy, Search, Shield, Unlink } from 'lucide-react'
import { Redirect, Route, Switch, useLocation } from 'wouter'
import {
  AppShell,
  SidebarBrand,
  SidebarSection,
  SidebarUserBlock,
  NavItem,
  Toaster,
} from '@ideon-api/ideon-ui'
import { useAuth0 } from '@auth0/auth0-react'
import { AuthGate } from './AuthGate'
import { DuplicateAccountsPage } from './pages/DuplicateAccountsPage'
import { UnlinkedSfdcPage } from './pages/UnlinkedSfdcPage'
import { AccountSearchPage } from './pages/AccountSearchPage'
import { AccountDetailPage } from './pages/AccountDetailPage'
import { PrivilegedCarriersPage } from './pages/PrivilegedCarriersPage'

export function Nav() {
  const [location, navigate] = useLocation()
  const isAccountsRoute = location === '/accounts' || location.startsWith('/accounts/')
  return (
    <>
      <SidebarSection label="Accounts">
        <NavItem
          variant={isAccountsRoute ? 'active' : 'default'}
          icon={<Search className="w-4 h-4" />}
          onClick={() => navigate('/accounts')}
        >
          Search
        </NavItem>
      </SidebarSection>
      <SidebarSection label="Review">
        <NavItem
          variant={location === '/duplicate-accounts' ? 'active' : 'default'}
          icon={<Copy className="w-4 h-4" />}
          onClick={() => navigate('/duplicate-accounts')}
        >
          Duplicate accounts
        </NavItem>
        <NavItem
          variant={location === '/unlinked-sfdc' ? 'active' : 'default'}
          icon={<Unlink className="w-4 h-4" />}
          onClick={() => navigate('/unlinked-sfdc')}
        >
          Unlinked SFDC
        </NavItem>
      </SidebarSection>
      <SidebarSection label="Admin">
        <NavItem
          variant={location === '/privileged-carriers' ? 'active' : 'default'}
          icon={<Shield className="w-4 h-4" />}
          onClick={() => navigate('/privileged-carriers')}
        >
          Privileged carriers
        </NavItem>
      </SidebarSection>
    </>
  )
}

function App() {
  const { user, logout } = useAuth0()

  return (
    <AuthGate>
      <AppShell
        nav={
          <>
            <SidebarBrand label="Identity Admin" />
            <Nav />
            <div className="flex-1" />
            <SidebarUserBlock
              name={user?.name ?? 'Unknown'}
              role="Ideon Staff"
              onSettingsClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            />
          </>
        }
      >
        <Switch>
          <Route path="/">
            <Redirect to="/accounts" replace />
          </Route>
          <Route path="/duplicate-accounts" component={DuplicateAccountsPage} />
          <Route path="/unlinked-sfdc" component={UnlinkedSfdcPage} />
          <Route path="/accounts" component={AccountSearchPage} />
          <Route path="/accounts/:slug" component={AccountDetailPage} />
          <Route path="/privileged-carriers" component={PrivilegedCarriersPage} />
        </Switch>
      </AppShell>

      <Toaster />
    </AuthGate>
  )
}

export default App
